import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TelegramService } from '../../../telegram.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize, Subject } from 'rxjs';
import { AuthService } from '../../../../../modules/auth/services/auth.service';
import { InterfaceService } from '../../../../../services/interface.service';
import { SenderService } from '../../../../../services/sender.service';

@Component({
  selector: 'app-sender-auth',
  templateUrl: './sender-auth.component.html',
  styleUrls: ['./sender-auth.component.scss']
})
export class SenderAuthComponent implements OnInit {
@Input() telegramService: TelegramService;
  Form: UntypedFormGroup;
  isLoading$: Subject<boolean> = new Subject();
  lastError: any;
  constructor(
    public authService: AuthService,
    public interfaceService: InterfaceService,
    public senderService: SenderService,
    public cd: ChangeDetectorRef,
) {
  }

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', Validators.required)
    });
  }

  onSubmit() {
    delete this.lastError;
    this.isLoading$.next(true);
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.senderService.senderAuthorize(values)
      .pipe(finalize(() => {
      this.isLoading$.next(false);
      this.cd.detectChanges();
    })).subscribe(
      (result: any) => {
        this.telegramService.setToken(result.token);
        this.telegramService.setAuth();
        this.telegramService.loadProfile();
        this.senderService.setAccount(result.account, this.telegramService);
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }

}
